import React from "react";
import createSvgIcon from "@material-ui/core/utils/createSvgIcon";

/**
 * author: Austin Andrews
 * id D88F139B-9D00-462D-8AA5-C23A5A02FCC6
 * name calendar-start
 * version: 5.7.55
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/calendar-start.svg
 * tags
 * - Date / Time 
 */
export const CalendarStartIcon = createSvgIcon(<><path d="M2 14H4V17H9V14L13 18L9 22V19H4V22H2V14M19 19V8H5V12H3L3 5C3 3.89 3.89 3 5 3H6V.998H8V3H16V.998H18V3H19C20.1 3 21 3.89 21 5V19C21 20.1 20.1 21 19 21L12.83 21L14.83 19L19 19Z" /></>, 'CalendarStartIcon');
export default CalendarStartIcon